export default class ChangeFieldworkOfficeItem {
  constructor() {
    this.OutsourcedJobLinkIds = [];
    this.NewFieldworkOfficeId = null;
    this.AllItemsSelected = false;
    this.SearchItem = null;
  }
}
